import React from 'react';

const PresentedDielineOptions = () => {
  const presentedDielineOptions = window.user_quote?.presented_dieline_options || {};
  const sortedEntries = Object.entries(presentedDielineOptions).sort();

  if (sortedEntries.length === 0) {
    return null;
  }

  return (
    <table className="table table-striped table-bordered-outside" style={{ marginTop: '10px' }}>
      <tbody>
        {sortedEntries.map(([key, value]) => (
          <tr key={key}>
            <td>{key}</td>
            <td align="right">{value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default PresentedDielineOptions;
